import { render, staticRenderFns } from "./update.vue?vue&type=template&id=c5f7b794&scoped=true&"
var script = {}
import style0 from "./update.vue?vue&type=style&index=0&id=c5f7b794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f7b794",
  null
  
)

export default component.exports